import { formTypes } from '.';
import { generalConceptsValueLabelList } from '../puc';

export const chargesFields = {
  id: { key: 'id', label: 'Número de cuenta de cobro' },
  issueDate: { key: 'issueDate', label: 'Fecha de creación', type: formTypes.date },
  dueDate: { key: 'dueDate', label: 'Fecha de vencimiento', type: formTypes.date },
  clientName: { key: 'clientName', label: 'Cliente', type: formTypes.selectComplete, options: [] }
};
